export { default } from './Confetti'
